import { store } from 'react-notifications-component';

import * as constants from './constants';

export default class Helper {

  static makeRequest = (endpoint, type, jwtToken, data, userId, contentType, useFullUrl = false) => {

    const fetchConfig = {
      method: type,
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*'
      }
    };
    
    if (contentType === 'automatic') fetchConfig.headers = { 'Accept': '*/*' };

    if (jwtToken !== null && jwtToken !== undefined) fetchConfig.headers.Authorization = `JWT ${ jwtToken }`;
    
    if (data !== null && data !== undefined) fetchConfig.body = data;

    const url = useFullUrl ?
      endpoint :
      constants.APP_ROOT_ENDPOINT + endpoint + (userId !== null && userId !== undefined ? `/${ userId }` : '');

    return fetch(url, fetchConfig);

  }

  static setNotification = (type, title, message, showTimer) => {

    store.addNotification({
      type: type,
      title: title,
      message: message,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: showTimer,
        pauseOnHover: true,
        showIcon: true
      }
    });

  }

  static handleErrorResponse = text => {

    let errorString = '';

    try {
      const response = JSON.parse(text);

      Object.values(response?.errors).forEach(errObj => {
        if (typeof(errObj) === 'string') return errorString = errObj;

        Object.values(errObj).forEach((err, index) => {
          errorString += (index >= 1 ? `\n${ err }` : err);
        });
      });
    }
    catch (e) {
      errorString = 'An unspecified error occured. Please try again later.';
    }
    
    return errorString;

  }

}